import React from 'react'
import styled from 'styled-components'
import { deviceLessThan, deviceGreaterThan } from '../../styles/breakpoints';

/*
*
* Product Feedback
*
*/

export const ProductFeedbackContainer = styled.div`
    display:flex; 
    min-height:100px; 
    width:70%; 
    flex-direction:row;
    justify-content:space-between; 
    padding: 47px 0px;
    margin: 20px -30% 20px 0px;
    background-color: #f2f8fe;
    @media ${deviceLessThan.desktopL} {
        width:100%; 
        margin: 20px 0px 20px 0px;
    }
    @media ${deviceLessThan.tablet} {
        flex-direction:column;
        width:100%; 
        margin:70px 0% 0px 0px;
        padding:10px;
        border-bottom-left-radius: 50% 10%;
        border-bottom-right-radius: 50% 10%;
        background:${props => props.sBackground && props.sBackground}
    }
   
`;

export const ProductFeedbackWrapper = styled.div`
    margin: 0px auto 0px 0px; 
    width:100%;
    text-align:center;
    padding: 5px;
    align-self:center;
    font-size:14px;
    & div span:last-child{
        opacity:0.6;
        font-weight:500;
        color:black;
        font-size:14px;
    }
    & > div span{
        color:#19447a;
        font-size:20px;
        font-weight:600;
    }
    & > div img{
        margin-bottom:5px
    }
    @media ${deviceLessThan.laptopS} { 
        padding: 0px;
    }
    @media ${deviceLessThan.tablet} {
        margin:15px 0px;
        padding: 0px;
    }
`;